// export { AuthHTTPService } from './auth-fake-http.service'; // You have to comment this, when your real back-end is done
export { AuthHTTPService } from './auth-http.service'; // You have to uncomment this, when your real back-end is done
